import {BonusExtraType, BonusStatus} from '@/stores/BonusesStore/BonusesStore.constants';

import {HttpAdapterUnsubscribeCallback, uuid4} from '@specials/project-user';

import {
  mockIsOpenedAllItemsError,
  mockNotificationsError,
  mockOnboardingError,
  mockOpenBonusError,
  mockOpenItemError,
} from '@/resources/mocks';
import {
  IProjectApi,
  OpenBonusPayload,
  OpenBonusResponse,
  OpenItemResponse,
  UpdateIsOpenedAllItems,
  UpdateIsSubscribedToNotificationsPayload,
} from '@/services/ProjectApi/types';

export class ProjectApiMock implements IProjectApi {
  public onUnauthorizedHttpErrorProject(): HttpAdapterUnsubscribeCallback {
    return () => {};
  }

  public onHttpErrorBackend(): HttpAdapterUnsubscribeCallback {
    return () => {};
  }

  public updateIsSubscribedToNotifications = async (
    _payload: UpdateIsSubscribedToNotificationsPayload,
  ): Promise<void> => {
    await this.wait(500);

    if (Math.random() > 0.9) {
      throw mockNotificationsError;
    }
  };

  public updateIsOpenedAllItems = async (_payload: UpdateIsOpenedAllItems): Promise<void> => {
    await this.wait(500);

    if (Math.random() > 0.9) {
      throw mockIsOpenedAllItemsError;
    }
  };

  public finishOnboarding = async (): Promise<void> => {
    await this.wait(500);

    if (Math.random() > 0.9) {
      throw mockOnboardingError;
    }
  };

  public openItem = async (itemId: string): Promise<OpenItemResponse> => {
    await this.wait(500);

    if (Math.random() > 0.9) {
      throw mockOpenItemError;
    }

    return {
      energyValue: 100,
      nextEnergyIn: 10000,
      userItem: {
        id: uuid4(),
        itemId,
        bonus: null,
        createdAt: '2024-11-19T09:57:04.874Z',
      },
    };
  };

  public openBonus = async ({itemId, bonusId}: OpenBonusPayload): Promise<OpenBonusResponse> => {
    await this.wait(500);

    if (Math.random() > 0.9) {
      throw mockOpenBonusError;
    }

    return {
      userItem: {
        id: uuid4(),
        itemId,
        bonus: {
          id: bonusId,
          status: BonusStatus.Active,
          extra: [
            {
              type: BonusExtraType.PromoCode,
              value: `PROMOCODE_${bonusId}`,
            },
          ],
        },
        createdAt: '2024-11-19T09:57:04.874Z',
      },
    };
  };

  private wait = (delay = 1000): Promise<void> => {
    return new Promise((r) => setTimeout(r, delay));
  };
}
